import { createSlice } from '@reduxjs/toolkit';
import {
    ultimoSuelo,
} from '../actions/ultimoSuelo';


export const UltimoSueloReducerNodo = createSlice({
    name: 'ultimoSuelo',
    initialState: {
        homeSort: {
            sortby: "_id",
            order: "desc",
            limit: 4,
            skip: 0
        },
        loading: false,
        sensores: [],
        current: null
    },
    reducers: {
    },
    extraReducers: (builder) => {
        builder
            // GET ARTICLE
            .addCase(ultimoSuelo.pending, (state) => { state.loading = true })
            .addCase(ultimoSuelo.fulfilled, (state, action) => {
                state.loading = false;
                state.current = action.payload
            })
            .addCase(ultimoSuelo.rejected, (state) => { state.loading = false })
    }
})

export default UltimoSueloReducerNodo.reducer;
